/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
/*
  ────────────────────────────────────────────────────────
  NOTE: Do NOT remove 'renderExpandable' prop. Even though
  it is not used in this file, it is used in parent files.
  ────────────────────────────────────────────────────────
*/
var RowTemplate = function (_a) {
    var alt = _a.alt, children = _a.children, renderExpandable = _a.renderExpandable, _b = _a.__TYPE, __TYPE = _b === void 0 ? 'RowTemplate' : _b;
    return React.createElement("div", null, children);
};
RowTemplate.defaultProps = {
    alt: true,
    __TYPE: 'RowTemplate',
};
export default RowTemplate;
